'use memo';

import { Link } from '@tanstack/react-router';
import { HStack, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography';
import { defaultNS, useTranslation } from '@/lib/i18n';
import type { ShadowServiceItem } from '@/routes/_staff/accesses/_layout/alerts/-query/type';
import { BentoCard, SeeMoreButton } from './BentoCard';
import type { ShadowType } from './ShadowTypeBadge';
import { ShadowTypeBadge } from './ShadowTypeBadge';
function toShadowType(violationType: ShadowServiceItem['violationType']): ShadowType {
  return violationType === 'SHADOW_ID' ? 'id' : 'it';
}
function ServiceRow({
  item
}: {
  item: ShadowServiceItem;
}) {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.accesses.overview.bento'
  });
  const {
    name,
    categories
  } = item.traceableApp;
  return <HStack className="items-center gap-2.5 border-t border-neutral-muted-fill py-2 first:border-t-0">
      {/* サービスロゴは外部画像が取得できないケースが多いため、頭文字のプレースホルダで表示する */}
      <span className="grid size-6 shrink-0 place-items-center rounded-md bg-neutral-muted-fill text-badgeLabel text-neutral-muted-on-fill">
        {name.charAt(0)}
      </span>
      <VStack className="min-w-0 gap-0">
        <Text variant="labelSmall" truncate className="text-neutral-on-fill">
          {name}
        </Text>
        {categories.length > 0 ? <Text variant="labelSmallReg" truncate className="text-neutral-muted-on-fill">
            {categories[0]}
          </Text> : null}
      </VStack>
      <VStack className="ml-auto shrink-0 items-end gap-0.5">
        <ShadowTypeBadge type={toShadowType(item.violationType)} />
        <Text variant="labelSmallReg" className="text-neutral-muted-on-fill">
          {item.uniqueUserCount.toLocaleString()}
          {t('newlyDetected.userUnit')}
        </Text>
      </VStack>
    </HStack>;
}

/** カード6: 新たに検知したサービス（アクセスの多い順 上位）。 */
export function NewlyDetectedCard({
  items,
  className
}: {
  items: ShadowServiceItem[];
  className?: string;
}) {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.accesses.overview.bento'
  });
  return <BentoCard className={className} title={t('newlyDetected.title')} headerRight={<SeeMoreButton>
          <Link to="/accesses/alerts" search={{
      alertTab: 'shadow-it'
    }}>
            {t('seeMore')}
          </Link>
        </SeeMoreButton>}>
      <VStack className="mt-1 gap-0">
        {items.map(item => <ServiceRow key={item.id} item={item} />)}
      </VStack>
    </BentoCard>;
}